import * as Select from '@studio/design-system/select';
import { Transport as M_Transport, toTransport } from '@studio/models/net';
import { useLatestFn, useLazyRef } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import type { Props } from './types.js';
import { Lang } from '#~/device/index.js';

/** `<Transport>` component. */
export const Transport = ({ size, transport, ...props }: Props): ReactElement => {
  const handleValueChange = useLatestFn((nextValue: string) => {
    const nextTransport = toTransport(nextValue);

    if (nextTransport && nextTransport !== transport.value) {
      transport(nextTransport);
    }
  });

  return (
    <Select.Root onValueChange={handleValueChange} size={size} value={transport.value}>
      <Select.Trigger {...props}>
        <Select.Value />
      </Select.Trigger>

      <Select.Content>
        {
          useLazyRef(() =>
            [M_Transport.TCP, M_Transport.UDP].map((µ) => (
              <Select.Item key={µ} value={µ}>
                {Lang.transport[µ]}
              </Select.Item>
            ))
          ).current
        }
      </Select.Content>
    </Select.Root>
  );
};
